import type {
  ImageField,
  KeyTextField,
  LinkField,
  RichTextField,
} from "@commercekit/prismic";
import Footer from "./__internal";
import type { FC } from "react";
import type {
  LayoutDocument,
  PaymentOptionsHorizontalSlice,
  CustomerReviewsBigSlice,
} from "~/lib/prismic";
import { useGlobalCtx } from "~/store/globalState";

const AppFooter: FC<{
  contact: RichTextField;
  contactTitle: KeyTextField;
  footerLogo: ImageField;
  footerCustomerNavLinkTitle: KeyTextField;
  footerCustomerNavLink: LayoutDocument["data"]["footerCustomerNavLink"];
  footerTipsNavLinksTitle: KeyTextField;
  footerTipsNavLinks: LayoutDocument["data"]["footerTipsNavLinks"];
  footerMoreNavLinkTitle: KeyTextField;
  footerMoreNavLink: LayoutDocument["data"]["footerMoreNavLink"];
  footerCopyrightLinks: LayoutDocument["data"]["footerCopyrightLinks"];
  socialMedias: LayoutDocument["data"]["socialMedias"];
  logoLink: LinkField;
  footerPaymentOptionSlices: PaymentOptionsHorizontalSlice[];
  footerCustomerReviewSlices: CustomerReviewsBigSlice[];
  headerRating?: { rating: number; reviewCount: number } | null;
  brandImage?: ImageField;
  customerReviews?: {
    id: string;
    rating: number;
    comment: string;
    createdAt: string;
    submittedAt: string;
    verificationType: string;
    customer: { fullName: string };
  }[] | null;
}> = (props) => {
  const { isShoppingCartLayout } = useGlobalCtx();
  return (
    <footer className="wvheader wvheader--footer-depth py-3 py-lg-0">
      {isShoppingCartLayout ? (
        <Footer.ShoppingCart {...props} />
      ) : (
        <Footer.General {...props} />
      )}
    </footer>
  );
};

export default AppFooter;
